import { useState, useEffect } from 'react';

export function useGeolocation() {
  const [location, setLocation] = useState(null);
  const [nearbyCity, setNearbyCity] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    let isMounted = true;
    
    async function fetchLocation() {
      try {
        const locationData = await fetchFromIpapi(controller.signal)
          || await fetchFromWtfismyip(controller.signal);

        if (!isMounted || !locationData) return;

        console.log('🌍 Geolocalização detectada:', {
          country: locationData.country_name,
          code: locationData.country_code,
          city: locationData.city,
        });

        setLocation(locationData);

        // Buscar cidade vizinha
        try {
          const nearbyCityName = await fetchNearbyCity(
            locationData.lat,
            locationData.lon,
            locationData.city
          );
          if (isMounted) {
            setNearbyCity(nearbyCityName || locationData.city);
          }
        } catch (err) {
          if (isMounted && err.name !== 'AbortError') {
            setNearbyCity(locationData.city);
          }
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('❌ Erro ao obter localização:', error);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    async function fetchFromIpapi(signal) {
      try {
        const response = await fetch('https://ipapi.co/json/', { signal });
        if (!response.ok) return null;
        const data = await response.json();
        if (!data.city || !data.latitude) return null;
        return {
          city: data.city,
          lat: data.latitude,
          lon: data.longitude,
          country_code: data.country_code,
          country_name: data.country_name,
        };
      } catch {
        return null;
      }
    }

    async function fetchFromWtfismyip(signal) {
      try {
        const response = await fetch('https://wtfismyip.com/json', { signal });
        if (!response.ok) return null;
        const data = await response.json();
        const parts = (data.YourFuckingLocation || '').split(',');
        const city = parts[0]?.trim() || 'Unknown';
        if (!data.YourFuckingCountryCode) return null;
        return {
          city,
          lat: data.YourFuckingLatitude || 0,
          lon: data.YourFuckingLongitude || 0,
          country_code: data.YourFuckingCountryCode,
          country_name: data.YourFuckingCountry || data.YourFuckingCountryCode,
        };
      } catch {
        return null;
      }
    }

    fetchLocation();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return { location, nearbyCity, loading };
}

// Função para buscar cidade vizinha usando GeoNames
async function fetchNearbyCity(lat, lon, currentCity) {
  try {
    const username = 'demo';
    const response = await fetch(
      `https://secure.geonames.org/findNearbyPlaceNameJSON?lat=${lat}&lng=${lon}&radius=50&maxRows=10&username=${username}&lang=pt`
    );
    
    const data = await response.json();
    
    if (data.geonames && data.geonames.length > 0) {
      // Retornar primeira cidade diferente da atual
      const cities = data.geonames
        .filter(place => place.name !== currentCity)
        .map(place => place.name);
      
      return cities[0] || cities[1] || cities[2] || currentCity;
    }
    
    return currentCity;
  } catch (error) {
    console.error('Erro ao buscar cidade vizinha:', error);
    return currentCity;
  }
}